import { useState } from "react";
import Modal from 'react-modal';
import useKeypress from "../ownHooks/pressEsc";


export default function BhfInaktiv({ rowEntry, deleteSpecificRow }) {
    const auth = sessionStorage.getItem('token');
    const [showModal, setShowModal] = useState(false);

    const openModal = event => {
        event.preventDefault();
        setShowModal(true);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const closeModal = () => {
        setShowModal(false);
    }

    const lockStation = event => {
        event.preventDefault();
        const bhfId = rowEntry.id;
        deleteSpecificRow(bhfId);
        console.log("locke: ", bhfId);
        closeModal();
    }

    if (auth.includes('level1') && !rowEntry.gesperrt) {
        return (
            <div>
                <button onClick={openModal}>&#10060;</button>
{/* &#129529;  */}
                {showModal && <Modal className="modal" isOpen={showModal}>
                    <button className="bttn-close-modal" onClick={closeModal}>&#10007; </button>

                    <p>Soll der Bahnhof wirklich gesperrt werden?</p>
                    <p className="text-cursive">{rowEntry.bahnhof} - {rowEntry.korr_zv} - {rowEntry.gueltig_von} - {rowEntry.gueltig_bis}</p>
                    <button onClick={lockStation}>Ja</button>
                    <button onClick={closeModal}>Nein</button>
                </Modal>}
            </div>
        )
    }
}